export const notificationSubscription = {
  toasts: {
    errorTitle: 'Eroare',
    successTitle: 'Succes',

    watchedSuccessfully: 'Abonarea la notificări a fost realizată cu succes',
    watchError: 'Eroare la abonarea la notificări',
    watchServerError: 'Eroare internă la abonarea la notificări',

    unwatchedSuccessfully: 'Dezabonarea de la notificări a fost realizată cu succes',
    unwatchError: 'Eroare la dezabonarea de la notificări',
    unwatchServerError: 'Eroare internă la dezabonarea de la notificări'
  },

  mainHeader: 'Notificări',

  watchTooltip: 'Abonare la notificări evenimente pentru document',
  unwatchTooltip: 'Dezabonare de la notificări evenimente pentru document',

  btn: {
    watch: 'Abonare',
    unwatch: 'Dezabonare'
  }
}
